
import { defineComponent, SetupContext, computed, ref, onMounted } from "vue";
import NativeClient from "@/client/native-client";
import { UsedUpPantryItem, PLATE_DELETE_FOOD_STATUS } from "@/types/pantry";
import DateUtil from "@/utils/date-util";
import PantryUsedUpCheckTagItem from "@/components/pantry/PantryUsedUpCheckTagItem.vue";
export default defineComponent({
  name: "PantryUsedUpCheckItem",
  components: {
    PantryUsedUpCheckTagItem
  },
  props: {
    data: {
      type: UsedUpPantryItem,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getImage = () => {
      return (props.data && props.data.info && props.data.info.imageUrl) ? props.data.info.imageUrl : "";
    };
    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("PantryUsedUpCheckItem onImageError");
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    const getName = () => {
      NativeClient.sendDebugLog("PantryUsedUpCheckItem props.data=" + JSON.stringify(props.data));
      return props.data && props.data.info ? props.data.info.name : "";
    };
    const getPurchaseDate = () => {
      let result = "--/--";
      if (
        props.data &&
        props.data.info &&
        props.data.info.purchaseDate
      ) {
        result = DateUtil.formatMMDD(props.data.info.purchaseDate);
      }
      return result;
    };
    const getActive = () => {
      return (props.data) ? props.data.foodStatus : PLATE_DELETE_FOOD_STATUS.NONE;
    };
    const onSelectTag = (foodStatus: number) => {
      NativeClient.sendDebugLog("PantryUsedUpCheckItem foodStatus=" + foodStatus + " props.data=" + JSON.stringify(props.data));
      context.emit("select-tag", props.data, foodStatus);
    };
    const styleText = computed(() => {
      const foodStatus = (props.data) ? props.data.foodStatus : PLATE_DELETE_FOOD_STATUS.NONE;
      return { textDecoration: foodStatus != PLATE_DELETE_FOOD_STATUS.NONE ? 'line-through' : 'none' };
    });
    return {
      PLATE_DELETE_FOOD_STATUS,
      getImage,
      getName,
      onImageError,
      getPurchaseDate,
      getActive,
      onSelectTag,
      styleText
    };
  }
});
